// 物流楼层
import classNames from 'classnames';
import React from 'react';

import ExpressStore from '@/stores/express';
import SkuStore from '@/stores/sku';

import MyLazyComponent from '@/common/lazy-load';
import localFormat from '@/common/local-format';
import roundNumber from '@/common/round-number';

interface PropType {
  type: SkuTypes.TypeInfo;
  moq: number;
  visitCountry: string;
  price: PriceTypes.Root;
  productId: number;
  productIsMarketGoods: boolean;
  sourcingTradeAvailable: boolean;
  i18n: DetailTypes.i18n;
  inventory: InventoryTypes.Root;
  renderConfig?: any;
  pcSemiSwitch?: boolean;
  moduleName?: string;
}

export default function Express(props: PropType) {
  const { type = 'product', visitCountry, i18n, price, pcSemiSwitch, renderConfig = {} } = props;
  const {
    currencyRule: { rate, maximumFractionDigits },
  } = price;
  // 请求物流
  const expressStore = ExpressStore(state => state);
  const skuStore = SkuStore(state => state);
  const { quantity } = skuStore[type];
  const { express, logisticPrice } = expressStore[type];
  const freeShippingAtmosphere = express?.activityMaterials;
  const ExpressDialog: any = renderConfig?.isSkuPanel ? (
    <></>
  ) : (
    MyLazyComponent(
      () => import(/* webpackChunkName: "express-dialog" */ './express-dialog'),
      <span>{i18n['marketAction_logistics_shippingFee']}</span>
    )
  );

  const renderName = () => {
    if (freeShippingAtmosphere && quantity === 0) {
      return localFormat(0);
    }
    // 免运费
    else if (express?.cost === 0) {
      return i18n['marketAction.freeShipping'];
    }
    // 数量0
    else if (quantity === 0) {
      return localFormat(0);
    }
    // 物流价格
    else if (express?.cost) {
      return localFormat(roundNumber(logisticPrice * rate, maximumFractionDigits));
    }
    // 无物流
    else {
      return i18n['rightAction.negotiated'];
    }
  };

  const renderExpress = () => {
    // 主搜面板不展示物流弹窗
    if (renderConfig?.isSkuPanel) {
      return <span>{i18n['pc_detail_sku_panel_shipping_fee']}</span>;
    }
    if (express.method) {
      return (
        <ExpressDialog
          price={price}
          type={type}
          country={visitCountry}
          calculateScene={type === 'sample' ? 'SAMPLE_DETAIL' : ''}
          productMainTypeEnum={type === 'sample' ? 'SAMPLE' : 'PRODUCT'}
        >
          {pcSemiSwitch ? (
            <span>{i18n['pc_detail_sku_panel_shipping_fee']}</span>
          ) : (
            <a href="#">{i18n['pc_detail_sku_panel_shipping_fee']}</a>
          )}
        </ExpressDialog>
      );
    }
    return <span>{i18n['pc_detail_sku_panel_shipping_fee']}</span>;
  };

  const renderPromotion = () => {
    if (express.saveCost && express.originalCost && quantity !== 0) {
      return (
        <del className="promotion">
          {localFormat(roundNumber(express.originalCost * rate, maximumFractionDigits))}
        </del>
      );
    }
    return null;
  };

  return (
    <div className="bottom-item">
      <div className="item-left">{renderExpress()}</div>
      <div
        className={classNames({
          'item-right': true,
        })}
        data-price-express={renderName()}
        data-price-promotion-express={
          express?.saveCost &&
          express.originalCost &&
          localFormat(roundNumber(express?.originalCost * rate, maximumFractionDigits))
        }
      >
        <span
          className={classNames({
            'free-shipping': freeShippingAtmosphere && express?.cost === 0 && quantity !== 0,
            'reduced-price': freeShippingAtmosphere && logisticPrice !== 0,
          })}
        >
          {renderName()}
        </span>
        {renderPromotion()}
      </div>
    </div>
  );
}
